export function getWhiteOutcomeImage(outcome) {
  switch (outcome.name) {
    case "Carbon Emissions":
      return "/statics/outcomes/white/Carbon - White.svg";
    case "Waste Management":
      return "/statics/outcomes/white/Waste - White.svg";
    case "Energy Management":
      return "/statics/outcomes/white/Energy - White.svg";
    case "Water":
      return "/statics/outcomes/white/Water - White.svg";
    case "Use SME's":
      return "/statics/outcomes/white/SME - White.svg";
    case "Use Local":
      return "/statics/outcomes/white/Using Local - White.svg";
    case "Charitable":
      return "/statics/outcomes/white/NFP - White.svg";
    case "Social Procurement":
      return "/statics/outcomes/white/Social Enterprise - White.svg";
    case "Eco Systems":
      return "/statics/outcomes/white/Eco - White.svg";
    case "Cultural":
      return "/statics/outcomes/white/Cultural - White.svg";
    case "Responsible Supply Chain":
      return "/statics/outcomes/white/Responsible Supply Chain - White.svg";
    case "Health & Wellbeing":
      return "/statics/outcomes/white/Health & Wellbeing - White.svg";
    // case "Training & Development":
    //   return "/statics/outcomes/Training & Development - Full Colour.svg";
    case "Diversity, Equity & Inclusion":
      return "/statics/outcomes/white/Diversity - White.svg";
    case "Sustainability Leadership":
      return "/statics/outcomes/white/Intentional Leadership - White.svg";
    case "Sustainability Innovation":
      return "/statics/outcomes/white/Innovation - White.svg";
    case "Training & Development":
      return "/statics/outcomes/white/Employment Opp - White.svg";
    default:
      return "";
  }
}
